// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { __decorate, __metadata, __param } from "tslib";
import { Inject, Scoped } from 'vue-di';
/* tslint:disable:no-unused-locals */
import { Serializer, } from '@trialcard/apigateway.models';
import { ApiKeyAuth, OAuth, OAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import { X_TC_USERID } from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols';
// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================
let EdgeEmailApi = class EdgeEmailApi {
    constructor(axios, xTcUserId, audience, url, tokenProvider) {
        this.axios = axios;
        this.authentications = {
            'ApiKey': new ApiKeyAuth('header', 'x-apikey'),
            'trialcard-poc.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'trialcard-test.auth0.com': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'Bearer': new ApiKeyAuth('header', 'Authorization'),
        };
        if (this.authentications.UserId) {
            this.authentications.UserId.apiKey = xTcUserId;
        }
    }
    /**
     *
     * @param isUnsubscribedRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async emailIsUnsubscribed(isUnsubscribedRequestModel, xProgramId) {
        const _url_ = '/edge/email/IsUnsubscribed';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'isUnsubscribedRequestModel' is not null or undefined
        if (isUnsubscribedRequestModel === null || isUnsubscribedRequestModel === undefined) {
            throw new Error('Required parameter isUnsubscribedRequestModel was null or undefined when calling emailIsUnsubscribed.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(isUnsubscribedRequestModel, "IsUnsubscribedRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailIsUnsubscribedDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param sendRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async emailSend(sendRequestModel, xProgramId) {
        const _url_ = '/edge/email/Send';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'sendRequestModel' is not null or undefined
        if (sendRequestModel === null || sendRequestModel === undefined) {
            throw new Error('Required parameter sendRequestModel was null or undefined when calling emailSend.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(sendRequestModel, "SendRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailSendDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param unsubscribeRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async emailUnsubscribe(unsubscribeRequestModel, xProgramId) {
        const _url_ = '/edge/email/Unsubscribe';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'unsubscribeRequestModel' is not null or undefined
        if (unsubscribeRequestModel === null || unsubscribeRequestModel === undefined) {
            throw new Error('Required parameter unsubscribeRequestModel was null or undefined when calling emailUnsubscribe.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(unsubscribeRequestModel, "UnsubscribeRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EmailUnsubscribeDefaultResponse");
        }
        return response;
    }
    /**
     *
     * @param unsubscribeBySourceNameRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    async unsubscribeUnsubscribeBySourceName(unsubscribeBySourceNameRequestModel, xProgramId) {
        const _url_ = '/edge/email/v2/Unsubscribe/unsubscribeBySourceName';
        let _params_ = {};
        let _headers_ = {};
        // verify required parameter 'unsubscribeBySourceNameRequestModel' is not null or undefined
        if (unsubscribeBySourceNameRequestModel === null || unsubscribeBySourceNameRequestModel === undefined) {
            throw new Error('Required parameter unsubscribeBySourceNameRequestModel was null or undefined when calling unsubscribeUnsubscribeBySourceName.');
        }
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");
        let requestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(unsubscribeBySourceNameRequestModel, "UnsubscribeBySourceNameRequestModel"),
        };
        await Promise.all([
            this.authentications['ApiKey'].applyToRequest(requestConfig),
            this.authentications['Bearer'].applyToRequest(requestConfig),
            this.authentications['Token'].applyToRequest(requestConfig),
            this.authentications['trialcard-poc.auth0.com'].applyToRequest(requestConfig),
            this.authentications['trialcard-test.auth0.com'].applyToRequest(requestConfig),
        ]);
        const response = await this.axios.request(requestConfig);
        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
};
EdgeEmailApi = __decorate([
    Scoped,
    __param(0, Inject(AXIOS)),
    __param(1, Inject(X_TC_USERID)),
    __param(2, Inject(AUDIENCE)),
    __param(3, Inject(BASE_PATH)),
    __param(4, Inject(OAUTH_TOKEN_PROVIDER)),
    __metadata("design:paramtypes", [Function, String, String, String, OAuthTokenProvider])
], EdgeEmailApi);
export { EdgeEmailApi };
//# sourceMappingURL=edgeEmailApi.js.map